import { render } from "./ReturnedItems.vue?vue&type=template&id=2e84967e"
import script from "./ReturnedItems.vue?vue&type=script&lang=js"
export * from "./ReturnedItems.vue?vue&type=script&lang=js"

import "./ReturnedItems.vue?vue&type=style&index=0&id=2e84967e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__